import InequalityFilterRow from './InequalityFilterRow';
import {action} from 'mobx';
import moment from 'moment';

class DateInequalityFilterRow extends InequalityFilterRow {
  @action parseValue(value) {
    return moment(value).toDate();
  }
}

export default DateInequalityFilterRow;
